<script setup lang="ts">
import './assets/style.scss'
import WCabinetMeterContent from './WCabinetMeterContent.vue'
import WCabinetMeterHeader from './WCabinetMeterHeader.vue'
import useModel from '../model/model'
import { computed, toRef, watch } from 'vue'
import { useSseConnection } from '@/shared/lib'
import { useRoute } from 'vue-router'

defineOptions({ name: 'meter' })

const props = defineProps({
  meterId: {
    type: Number,
    required: true,
  },
  objectId: {
    type: Number,
    required: false,
  },
})

const { meter, limits, contactorStatus, isMonitoring, isSummaryLimits, loadData } = useModel()
const route = useRoute()

const { refetch } = loadData(toRef(props, 'meterId'))

/* Устанавливаем SSE соединение */
const objectId = computed(() => Number(props.objectId || route.params.object_id))

const { handler } = useSseConnection(async (res: { meter_id: number }) => {
  if (res.meter_id && res.meter_id === props.meterId) await refetch()
})

watch(
  () => objectId,
  () => {
    handler(`/cabinets/${objectId.value}/statuses`)
  },
  { immediate: true },
)
</script>

<template>
  <div v-if="meter" class="w-cabinet-meter__title" v-bind="$attrs">
    <WCabinetMeterHeader :meter />
  </div>

  <WCabinetMeterContent
    v-if="meter"
    :meter
    :limits
    :contactorStatus
    :isMonitoring
    :isSummaryLimits
    :objectId
  />
</template>
